/* tslint:disable */
/* eslint-disable */
/**
 * deleteBusinessManage API
 * 登録されている取引情報を削除するAPI管理
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 取引削除を実行した時のレスポンス
 * @export
 * @interface DeleteAllBusinessResponse
 */
export interface DeleteAllBusinessResponse {
    /**
     * 
     * @type {number}
     * @memberof DeleteAllBusinessResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof DeleteAllBusinessResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof DeleteAllBusinessResponse
     */
    'message': string;
    /**
     * 
     * @type {DeleteAllBusinessResponseAllOfResult}
     * @memberof DeleteAllBusinessResponse
     */
    'result': DeleteAllBusinessResponseAllOfResult;
}
/**
 * 
 * @export
 * @interface DeleteAllBusinessResponseAllOfResult
 */
export interface DeleteAllBusinessResponseAllOfResult {
    /**
     * 
     * @type {object}
     * @memberof DeleteAllBusinessResponseAllOfResult
     */
    'data': object;
}
/**
 * エラーレスポンス
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'headers': string;
    /**
     * 
     * @type {ErrorResponseBody}
     * @memberof ErrorResponse
     */
    'body': ErrorResponseBody;
}
/**
 * 
 * @export
 * @interface ErrorResponseBody
 */
export interface ErrorResponseBody {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponseBody
     */
    'statusCode': number;
    /**
     * 
     * @type {ErrorResponseCode}
     * @memberof ErrorResponseBody
     */
    'code': ErrorResponseCode;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseBody
     */
    'message': string;
}


/**
 * エラー時のレスポンスコード backendのcommon_layer/return_code.py参照
 * @export
 * @enum {string}
 */

export const ErrorResponseCode = {
    BadRequest: 'BAD_REQUEST',
    NotRegisteredBusiness: 'NOT_REGISTERED_BUSINESS',
    FkConstraintFailed: 'FK_CONSTRAINT_FAILED',
    Unauthorized: 'UNAUTHORIZED',
    Forbidden: 'FORBIDDEN',
    NotFound: 'NOT_FOUND',
    ResourceConflict: 'RESOURCE_CONFLICT',
    UpdateTimingConflict: 'UPDATE_TIMING_CONFLICT',
    InternalServerError: 'INTERNAL_SERVER_ERROR'
} as const;

export type ErrorResponseCode = typeof ErrorResponseCode[keyof typeof ErrorResponseCode];


/**
 * 成功レスポンス
 * @export
 * @interface SuccessResponse
 */
export interface SuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof SuccessResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof SuccessResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof SuccessResponse
     */
    'message': string;
    /**
     * 
     * @type {object}
     * @memberof SuccessResponse
     */
    'result': object;
}

/**
 * DeleteBusinessApi - axios parameter creator
 * @export
 */
export const DeleteBusinessApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary リクエストで送った組織IDを持っている登録情報を全て削除する（デバッグメニュー用）
         * @param {boolean} useInitData 初期データ(sql)を流し込むかどうか
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllBusiness: async (useInitData: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'useInitData' is not null or undefined
            assertParamExists('deleteAllBusiness', 'useInitData', useInitData)
            const localVarPath = `/debug-delete-all-business`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (useInitData !== undefined) {
                localVarQueryParameter['useInitData'] = useInitData;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeleteBusinessApi - functional programming interface
 * @export
 */
export const DeleteBusinessApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeleteBusinessApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary リクエストで送った組織IDを持っている登録情報を全て削除する（デバッグメニュー用）
         * @param {boolean} useInitData 初期データ(sql)を流し込むかどうか
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAllBusiness(useInitData: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteAllBusinessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAllBusiness(useInitData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeleteBusinessApi.deleteAllBusiness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DeleteBusinessApi - factory interface
 * @export
 */
export const DeleteBusinessApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeleteBusinessApiFp(configuration)
    return {
        /**
         * 
         * @summary リクエストで送った組織IDを持っている登録情報を全て削除する（デバッグメニュー用）
         * @param {boolean} useInitData 初期データ(sql)を流し込むかどうか
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllBusiness(useInitData: boolean, options?: any): AxiosPromise<DeleteAllBusinessResponse> {
            return localVarFp.deleteAllBusiness(useInitData, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeleteBusinessApi - object-oriented interface
 * @export
 * @class DeleteBusinessApi
 * @extends {BaseAPI}
 */
export class DeleteBusinessApi extends BaseAPI {
    /**
     * 
     * @summary リクエストで送った組織IDを持っている登録情報を全て削除する（デバッグメニュー用）
     * @param {boolean} useInitData 初期データ(sql)を流し込むかどうか
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeleteBusinessApi
     */
    public deleteAllBusiness(useInitData: boolean, options?: RawAxiosRequestConfig) {
        return DeleteBusinessApiFp(this.configuration).deleteAllBusiness(useInitData, options).then((request) => request(this.axios, this.basePath));
    }
}



